import { WDHFlexspotPardotForm } from './src/js/WDHFlexspotPardotForm';

/**
 * @module WDHFlexspotPardotForm
 */
export { WDHFlexspotPardotForm };